import { render, staticRenderFns } from "./FlooringSelections.vue?vue&type=template&id=633c6166&scoped=true&"
import script from "./FlooringSelections.vue?vue&type=script&lang=js&"
export * from "./FlooringSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c6166",
  null
  
)

export default component.exports